import { Component, OnInit, Input } from '@angular/core';
import { MaterialsSchemaDto } from "../../data/CommandServiceDtos.generated";

@Component({
  standalone: false,
  selector: 'project-materials-stage',
  templateUrl: './project-materials-stage.component.html',
  styleUrls: ['./project-materials-stage.component.scss']
})
export class ProjectMaterialsStageComponent implements OnInit {
  @Input() schema: MaterialsSchemaDto;

  constructor() { }

  ngOnInit() {
  }

}
